export default "__VITE_ASSET__CmfivS8$__"